<p-dialog class="dynamic-popup" [blockScroll]="true" [modal]="true" [showHeader]="false" [responsive]="true"
    [style]="style" [(visible)]="visible" (onHide)="onClose()">
    <div class="calender-container" *ngIf="isVisible">
        <div>
            <div class="team-member-shift">
                <div style="float: left;">
                    <span class="team-member">Team Member Shift Details</span>
                </div>
                <div style="float: right;">
                    <button pButton (click)="closePopupCal()" class="close-button">X</button>
                </div>
                <div style="clear: both;"></div> <!-- Clears the floats -->
            </div>

            <div>
                <div>
                    <div *ngFor="let user of teamMemberList">
                        <div *ngFor="let shift of user?.siftPlannings" [ngClass]="{'mask-copy': shift}"
                            class="shift-planning">

                            <!-- Team Name with no extra space -->
                            <span class="first-header shift-name" style="">{{ shift.teamName }}</span>

                            <!-- Time range -->
                            <span class="first-header shift-time" style="">{{ shift.startTimeStr }} - {{
                                shift.endTimeStr }} </span>

                            <!-- Start Date and End Date -->
                            <span class="first-header shift-time" style="">| Start Date: {{ shift.startDateStr }}
                            </span>
                            <span class="first-header shift-time">| End Date: {{ shift.endDateStr }}</span>
                        </div>
                    </div>
                </div>


                <div class="dived-border calendar-section-divider"></div>

                <div class="calendar-header-row">
                    <div class="calendar-nav">
                        <div class="display-month">
                            <h4>{{ displayedMonth | date: 'MMMM y' }}</h4>
                        </div>
                        <div class="arrow-wrapper">
                            <div class="left-arrow" (click)=" previousMonth()">
                            <svg width="9px" height="14px" viewBox="0 0 9 14" version="1.1"
                                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <g id="Designs" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <g id="1-Shift-Calendar" transform="translate(-1369.000000, -255.000000)"
                                        fill="#334CBD" fill-rule="nonzero">
                                        <g id="Group-38" transform="translate(235.000000, 80.000000)">
                                            <g id="Group-34" transform="translate(1068.000000, 172.000000)">
                                                <g id="Group-26-Copy"
                                                    transform="translate(83.317073, 10.000000) scale(-1, 1) translate(-83.317073, -10.000000) translate(66.000000, 3.000000)">
                                                    <path
                                                        d="M30.4755865,11.1585366 C30.224678,11.1585366 29.9738005,11.0586925 29.7825052,10.8594241 L23.7628083,4.58571559 C23.3798769,4.18662989 23.3798769,3.53958084 23.7628083,3.1406566 C24.1455847,2.74173235 24.7663183,2.74173235 25.1492807,3.1406566 L30.4755865,8.69198096 L35.8019234,3.14085034 C36.1848547,2.7419261 36.8055264,2.7419261 37.1882718,3.14085034 C37.5713891,3.53977459 37.5713891,4.18682364 37.1882718,4.58590933 L31.1686678,10.8596179 C30.9772796,11.0589185 30.7264021,11.1585366 30.4755865,11.1585366 Z"
                                                        id="Path-Copy-9"
                                                        transform="translate(30.475610, 7.000000) scale(-1, 1) rotate(90.000000) translate(-30.475610, -7.000000) ">
                                                    </path>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </div>
                        <div class="right-arrow" (click)="nextMonth()">
                            <svg width="9px" height="14px" viewBox="0 0 9 14" version="1.1"
                                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <g id="Designs" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <g id="1-Shift-Calendar" transform="translate(-1395.000000, -255.000000)"
                                        fill="#334CBD" fill-rule="nonzero">
                                        <g id="Group-38" transform="translate(235.000000, 80.000000)">
                                            <g id="Group-34" transform="translate(1068.000000, 172.000000)">
                                                <g id="Group-26-Copy"
                                                    transform="translate(83.317073, 10.000000) scale(-1, 1) translate(-83.317073, -10.000000) translate(66.000000, 3.000000)">
                                                    <path
                                                        d="M4.15851335,11.1585366 C3.90760485,11.1585366 3.65672734,11.0586925 3.46543208,10.8594241 L-2.5542649,4.58571559 C-2.93719625,4.18662989 -2.93719625,3.53958084 -2.5542649,3.1406566 C-2.17148847,2.74173235 -1.55075485,2.74173235 -1.16779252,3.1406566 L4.15851335,8.69198096 L9.4848502,3.14085034 C9.86778155,2.7419261 10.4884532,2.7419261 10.8711986,3.14085034 C11.2543159,3.53977459 11.2543159,4.18682364 10.8711986,4.58590933 L4.85159462,10.8596179 C4.6602064,11.0589185 4.40932889,11.1585366 4.15851335,11.1585366 Z"
                                                        id="Path-Copy-8"
                                                        transform="translate(4.158537, 7.000000) rotate(90.000000) translate(-4.158537, -7.000000) ">
                                                    </path>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                            </div>
                        </div>
                    </div>

                    <div class="availability-box">
                        <h4 class="member" translate>label_team_shift_availability</h4>
                        <div class="availability-wrapper">
                            <div class="ui-availabilty-block"
                                *ngFor="let memberShiftAvailability of memberShiftAvailabilityList">
                                <span class="rect-block" [ngClass]="memberShiftAvailability?.value"></span>
                                <span class="rect-text">{{memberShiftAvailability?.label}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div>
            <div class="calendar" style="position: relative;">
                <div class="days-header">
                    <div class="day">Mon</div>
                    <div class="day">Tue</div>
                    <div class="day">Wed</div>
                    <div class="day">Thu</div>
                    <div class="day">Fri</div>
                    <div class="day">Sat</div>
                    <div class="day">Sun</div>
                </div>
            
                <div class="days">
                    <div class="day" *ngFor="let day of calenderDays">
                        <div [ngClass]="{ 'highlight': isToday(day?.calenderDay) }" style="padding:4px">
                            <span>{{ day?.calenderDay !== null ? day?.calenderDay : '' }}</span>
                        </div>

                        <div [ngClass]="{
                          'unavailable': day?.memberStatusStr === 'Unavailable',
                          'timeoff': day?.memberStatusStr === 'Time Off',
                          'available': day?.memberStatusStr === 'Available'
                        }">
                            <div class="slot-wrapper">
                                <div class="day-cell-content">

                                    <!-- Display Team Name for Available or Time Off -->
                                    <div *ngIf="day?.groupedTeams?.length > 0 && (day?.memberStatusStr === 'Available' || day?.memberStatusStr === 'Time Off')"
                                        class="name-team">
                                        <div>
                                            {{ day?.groupedTeams[0]?.teamName }}
                                        </div>
                                    </div>

                                    <!-- Display Unavailable Status -->
                                    <div *ngIf="day?.memberStatusStr === 'Unavailable'" class="Unavailable">
                                        Unavailable
                                    </div>

                                    <!-- Display Slots and Leave Types -->
                                    <!--  -->
                                    <div *ngIf="day?.groupedTeams?.length > 0" class="time-slot">
                                        <!-- Access the first team directly -->
                                        <ng-container *ngIf="day.groupedTeams[0] as team">
                                            <!-- Display Slots -->
                                            <ng-container *ngIf="team.leaveTypes?.length === 0 || team.slots?.length > 0">
                                                <span >
                                                  <div *ngFor="let slot of team.slots | slice:0:3">
                                                   <span [ngClass]="{ 'duty-on-off-background': slot?.scheduleSource === 'DUTY_ON_OFF' }">{{ slot.slotTimeStr }}</span> 
                                                  </div>
                                                </span>
                                              </ng-container>
                                            <ng-container *ngIf="team.leaveTypes?.length > 0">
                                                <div *ngFor="let leave of team.leaveTypes" style="color: #d91919">
                                                    <!-- Check for All Day Leave -->
                                                    <ng-container
                                                        *ngIf="leave.slotTimeStr === '12:00 AM to 11:59 PM'; else displayLeaveType">
                                                        PTO (All Day)
                                                    </ng-container>
                                                    <ng-template #displayLeaveType>
                                                        {{ leave.leaveType }} ({{ leave.slotTimeStr }})
                                                    </ng-template>
                                                </div>
                                            </ng-container>
                                       
                                        </ng-container>
                                    </div>


                                    <!-- More Teams Dialog -->
                                    <div *ngIf="day?.groupedTeams?.length > 0" class="more">
                                        <a [hidden]="day.groupedTeams?.length <= 1" (click)="toggleDialog(day)"
                                            class="more-button">
                                            {{ day.groupedTeams?.length - 1 }} More
                                        </a>

                                        <div *ngIf="activeDay === day && displayDialog" class="inline-dialog">
                                            <div class="dialog-con dialog-content flex-column">
                                                <div class="col-1">
                                                    <span>
                                                        <button (click)="closeDialog()" class="close-button">✕</button>
                                                    </span>
                                                </div>
                                                <div class="col-2">
                                                    <div *ngFor="let team of day.groupedTeams">
                                                        <div class="team-info">
                                                            <div>
                                                                <span class="main-team">{{ team.teamName }}:</span>
                                                                <span class="time">
                                                                   <!--  <span *ngIf="team.slots?.length > 0"
                                                                        class="first-slot" [ngStyle]="{'background-color': team?.scheduleSource === 'DUTY_ON_OFF' ? '#fcedce' : ''}">
                                                                        {{ team.slots?.slotTimeStr }}
                                                                    </span> -->
                                                                    <ng-container *ngIf="team.slots?.length > 0">
                                                                        <span *ngFor="let slot of team.slots" 
                                                                              class="first-slot" 
                                                                              [ngStyle]="{'background-color': slot?.scheduleSource === 'DUTY_ON_OFF' ? '#fcedce' : ''}">
                                                                          {{ slot.slotTimeStr }}
                                                                        </span>
                                                                      </ng-container>
                                                                      

                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div *ngIf="team.leaveTypes?.length > 0">
                                                            <div *ngFor="let leave of team.leaveTypes"
                                                                style="color: #d91919">
                                                                <!-- Check for All Day Leave -->
                                                                <ng-container
                                                                    *ngIf="leave.slotTimeStr === '12:00 AM to 11:59 PM'; else detailedLeave">
                                                                    PTO (All Day)
                                                                </ng-container>
                                                                <ng-template #detailedLeave>
                                                                    {{ leave.leaveType }} ({{ leave.slotTimeStr }})
                                                                </ng-template>
                                                            </div>
                                                        </div>
                                                       
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="square"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>

    </div>
</p-dialog>